<template>
    <el-dialog
    title="预约"
    :visible.sync="appointVisible"
    width="98%"
    class="frame-dialog net-appoint-dialog"
    :before-close="closeDialogOnly"
    :close-on-click-modal="false"
    :modal="false">
        <div class="net-appoint" v-loading="getListLoading">
            <div class="appoint-left">
                <div class="base-info">
                    <el-form label-position="right" label-width="110px" :model="appointInfo" v-if="rowData && rowData.orderType">
                        <template>
                            <el-form-item label="收货人：">{{rowData.netTaskAddress.receiverName||rowData.receiverName}}</el-form-item>
                            <el-form-item label="电话：">{{rowData.netTaskAddress.receiverMobile||rowData.receiverMobile}}</el-form-item>
                            <el-form-item label="四级地址：">
                                {{rowData.netTaskAddress.receiverProvinceName||'-'}} /
                                {{rowData.netTaskAddress.receiverCityName||'-'}} /
                                {{rowData.netTaskAddress.receiverDistrictName||'-'}} /
                                {{rowData.netTaskAddress.receiverTownName||'-'}}</el-form-item>
                            <el-form-item label="详细地址：">{{rowData.netTaskAddress.receiverDetailAddr||''}}</el-form-item>
                        </template>
                    </el-form>
                </div>
                <div class="appoint-edit-info">
                    <appoint-edit-cont ref="appointEditInfo"
                    :rowData="rowData"
                    :saveFlag="saveFlag"
                    @saveResult="saveResult"></appoint-edit-cont>
                </div>
            </div>
            <div class="appoint-right">
                <dialog-table ref="appointTable" :tableData="appointDataLists" :dialogTable="appointTableColumns"
                    @selectionChange="selectionChange">
                </dialog-table>
            </div>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialogOnly">取 消</el-button>
            <el-button type="primary" @click="handleSave">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import dialogTable from '../../../../../components/dialog/dialogTable';
import AppointEditCont from './AppointEditCont';
import api from '../../../../../api/netTaskManage2c.js';
import { cainiaoColumns } from './config';

export default {
    components: { dialogTable, AppointEditCont },
    data() {
        return {
            appointTableColumns: cainiaoColumns,
            rowData: {},
            appointVisible: false,
            appointDataLists: [],
            selectedData: [],
            getListLoading: false,
            appointInfo: {},
            saveFlag: true
        };
    },
    methods: {
        selectionChange(data) {
            this.selectedData = data;
        },
        handleSave() {
            this.$refs.appointEditInfo.checkSave(this.appointDataLists);
        },
        async show(rowData) {
            // 菜鸟2B订单模式：需同一客户订单下所有订单签收完成后，才可以预约
            this.rowData = rowData;
            this.appointDataLists = [rowData];
            const params = {
                sourceSystem: 'CAINIAO',
                businessMode: 'B2B',
                orderType: 'PO',
                receiverMobile: rowData.receiverMobile || rowData.netTaskAddress.receiverMobile,
                customerOrderNo: rowData.customerOrderNo,
                orderStatusList: ['100', '120', '130', '140', '145'],
                pageNo: 1,
                pageSize: 2000
            };
            this.getListLoading = true;
            let currentInx;
            let count = 0;
            let totalQty = 0;
            await api
                .getLists(params)
                .then((res) => {
                    if (res && res.code === '0') {
                        res.data.list.map((item, idx) => {
                            if (item) {
                                item.netTaskItems.forEach(items => {
                                    count += items.netRealReceive;
                                });
                                totalQty = item.customerTotalQty;
                                if (item.orderNo === rowData.orderNo) {
                                    currentInx = idx;
                                }
                                if (item.expectArriveStartTime &&
                                    item.expectArriveEndTime) {
                                    item.expectDeliveryTime =
                                    item.expectArriveStartTime +
                                    '-' + item.expectArriveEndTime.split(' ')[1];
                                } else if (item.expectArriveStartTime &&
                                        !item.expectArriveEndTime) {
                                    item.expectDeliveryTime =
                                        item.expectArriveStartTime.split(' ')[0] + ' 00:00:00-23:59:59';
                                }
                                if (item.expectInstallStartTime &&
                                    item.expectInstallEndTime) {
                                    item.expectInstallTime =
                                    item.expectInstallStartTime +
                                    '-' + item.expectInstallEndTime.split(' ')[1];
                                } else if (item.expectInstallStartTime &&
                                        !item.expectInstallEndTime) {
                                    item.expectInstallTime =
                                        item.expectInstallStartTime.split(' ')[0] + ' 00:00:00-23:59:59';
                                }
                                if (item.firstAppointmentStartTime &&
                                    item.firstAppointmentEndTime) {
                                    item.firstAppointmentTime =
                                    item.firstAppointmentStartTime +
                                    '-' + item.firstAppointmentEndTime.split(' ')[1];
                                }
                                item.itemClassName = item.itemClassName || item.netTaskItems ? item.netTaskItems[0].itemClassName : '';
                                item.itemName = item.itemName || item.netTaskItems ? item.netTaskItems[0].itemName : '';
                            }
                        });
                        // 当前订单推到第一行
                        if (currentInx) res.data.list.unshift(res.data.list.splice(currentInx, 1)[0]);
                        this.appointDataLists = res.data.list;
                    }
                })
                .catch(() => {});
            this.$nextTick(() => {
                this.appointVisible = true;
                if (count !== totalQty) {
                    this.saveFlag = false;
                    this.$message.warning('天猫优品同一客户订单号需要全部签收后，才能预约');
                    this.closeDialogOnly();
                };
                this.getListLoading = false;
            });
        },
        saveResult(res) {
            if (res) {
                this.$message.success('预约成功');
                this.closeAndRefresh();
            }
        },
        closeDialogOnly() {
            this.$emit('closeDialog', 'appointmentNewDialog', false);
        },
        closeAndRefresh() {
            this.$emit('closeDialog', 'appointmentNewDialog', true);
        }
    }
};
</script>
<style lang="less">
.net-appoint-dialog {
    min-width: 900px;
    .el-dialog__body {
        padding-top: 0;
    }
}
.net-appoint {
    display: flex;
    .appoint-left {
        width: 30%;
        padding: 10px 10px 0 0;
        border-right: 1px solid #e6e6e6;
        .el-form-item__label {
            color: #999;
        }
        .el-form-item__content {
            color: #333;
        }
        .el-form-item__content, .el-form-item__label {
            line-height: 24px;
        }
        .base-info {
            min-height: 66%;
            border-bottom: 1px solid #e6e6e6;
            margin-bottom: 10px;
            padding-bottom: 5px;
            .el-form {
                height: 100%;
            }
            .el-form-item {
                height: 12%;
                margin-bottom: 20px;
            }
            .el-form-item__label {
                font-weight: 600;
                color: #00BCBF;
            }
        }
    }
    .appoint-right {
        width: 68%;
        padding: 10px 0 0 10px;
    }
    .summarizing {
        margin-top: 5px;
        :first-child {
            margin-right: 25px;
        }
        i {
            color: #000;
            font-style: normal;
        }
    }
}
</style>